/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractOperandValueImpl, AbstractOperandValueImplBaseRecordClassFactory } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/AbstractOperandValueImplBaseRecordClassFactory";
import { OperatorOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/OperatorOperandValueImpl";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { Optional } from "abweb/utils/optional/Optional";
import Immutable from "immutable";
const defaultState = {
  ...AbstractOperandValueImpl.getDefaultState(),
  expExpressionNodeNodeType: undefined,
  operandValuesByNodeId: Immutable.Map()
};
export class ActionListOperandValueImpl extends new AbstractOperandValueImplBaseRecordClassFactory().createBaseRecordClass(defaultState) {
  constructor(stateWithoutNodeType) {
    super({
      expExpressionNodeNodeType: ExpExpressionNodeNodeTypeEnum.ACTION_LIST,
      ...stateWithoutNodeType
    });
  }
  withOperandValuesByNodeId(operandValuesByNodeId) {
    return this.with({
      operandValuesByNodeId
    });
  }
  transformRecursive(transformer, predicate) {
    let transformed = super.transformRecursive(transformer, predicate);
    let {
      operandValuesByNodeId
    } = transformed;
    for (const operandName of operandValuesByNodeId.keySeq().toArray()) {
      operandValuesByNodeId = operandValuesByNodeId.set(operandName, operandValuesByNodeId.get(operandName).transformRecursive(transformer, predicate));
    }
    return transformed.withOperandValuesByNodeId(operandValuesByNodeId);
  }
  stateWithoutNodeType() {
    return {
      ...super.stateWithoutNodeType(),
      operandValuesByNodeId: this.operandValuesByNodeId
    };
  }
  toExpExpressionNode() {
    const expExpressionNode = super.toExpExpressionNode();
    expExpressionNode.operandValues = [];
    for (const operandValue of this.operandValuesByNodeId.valueSeq().toArray()) {
      Assert.assert(OperatorOperandValueImpl.isInstance(operandValue));
      expExpressionNode.operandValues.push(operandValue.toExpExpressionNode());
    }
    return expExpressionNode;
  }
}
(function (_ActionListOperandValueImpl) {
  function getDefaultState() {
    return defaultState;
  }
  _ActionListOperandValueImpl.getDefaultState = getDefaultState;
  function isInstance(operandValue) {
    return ClassUtils.isInstanceOf(operandValue, ActionListOperandValueImpl);
  }
  _ActionListOperandValueImpl.isInstance = isInstance;
  function cast(operandValue) {
    Assert.assert(isInstance(operandValue));
    return operandValue;
  }
  _ActionListOperandValueImpl.cast = cast;
  function castNullable(operandValue) {
    return Optional.of(operandValue).map(cast).get();
  }
  _ActionListOperandValueImpl.castNullable = castNullable;
})(ActionListOperandValueImpl || (ActionListOperandValueImpl = {}));
//# sourceMappingURL=ActionListOperandValueImpl.js.map
